var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"grey lighten-4",attrs:{"size":"36px"}},[(!_vm.$store.state.userImage)?_c('img',{attrs:{"src":_vm.assets('blank-profile-picture.png'),"alt":"avatar"}}):_c('img',{attrs:{"src":_vm.userImg(this.$store.state.userImage),"alt":"avatar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }